<template>
  <div class="animated fadeIn">

    <b-card-body>
      <b-row>
        <b-col sm xs="12" class="text-left mt-3">
          <router-link to="/guichets/create" v-if="can('approvisionnement-create-for-guichet')">
            <b-button variant="primary" class="btn-pill">
              <i class="fa fa-plus"></i>&nbsp;Nouveau
            </b-button>
          </router-link>
        </b-col>
      </b-row>
    </b-card-body>
    <b-row>
     <b-col lg="12">
        <!--<c-table-entities striped caption="<i class='fa fa-align-justify'></i> Liste des entités"></c-table-entities>-->
          <div>
              <vue-good-table :columns="columns" styleClass="vgt-table condensed bordered striped" :rows="rows" :fixed-header="false" :pagination-options="pagination" :search-options="search" @on-sort-change="onSortChange" @on-column-filter="onColumnFilter">
                <template slot="table-row" slot-scope="props">
                    <span v-if="props.column.field == 'btn'" style="font-size: 0.875rem;">
                        <b-dropdown id="ddown-sm-split" size="sm" text="Plus de détails" class="m-2">
                            <div role="group" aria-lableledby="header1">                   
                              <router-link :to="'/historique/approvisionnement/'+ props.row.id">
                                <b-dropdown-item-button aria-describedby="header2"><i class="fa fa-users"></i> Historique des activités</b-dropdown-item-button>
                              </router-link>
                          </div>
                        </b-dropdown> 
                    </span>
                    <span style="font-size: 0.875rem;" v-else>
                      {{props.formattedRow[props.column.field]}}
                    </span> 
                </template>
              </vue-good-table>
          </div>
      </b-col><!--/.col-->
    </b-row><!--/.row-->
  </div>

</template>

<script>
//import cTableEntities from './TableEntities.vue'
import { VueGoodTable } from 'vue-good-table';
import { mapState, mapActions } from 'vuex';
export default {
  name: 'tables',
  //components: {cTableEntities},
  components: {VueGoodTable},
   data(){
    return {
      columns: [
        {
          label: 'Utilisateur',
          field: 'user',
          width: '200px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Montant',
          field: 'montant',
          type: 'number',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Guichet',
          field: 'approvisionnementable',
          width: '150px',
          filterable: true,
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Crée le',
          field: 'created_at',
          width: '150px',
          type: 'date',
          dateInputFormat: 'YYYY-MM-DD',
          dateOutputFormat: 'YYYY-MM-DD',
          formatFn: this.formatFn,
          filterable: true,
          thClass: 'custom-th-class',
          filterOptions: {
            enabled: true, // enable filter for this column
            placeholder: 'Filter This Thing', // placeholder for filter input
            filterValue: '', // initial populated value for this filter
            filterDropdownItems: [], // dropdown (with selected values) instead of text input
            filterFn: this.columnFilterFn, //custom filter function that
            trigger: 'keyup', //only trigger on enter not on keyup 
          },
        },
        {
          label: 'Action',
          field: 'btn',
          html: true,
          width: '150px',
        }
      ],
      rows: [],
      pagination:{
          enabled: true,
          mode: 'pages',
          perPage: 10,
          position: 'bottom',
          perPageDropdown: [3,5, 10, 50,100],
          dropdownAllowAll: false,
          setCurrentPage: 1,
          nextLabel: 'Suivant',
          prevLabel: 'Précédent',
          rowsPerPageLabel: 'Lignes par page',
          ofLabel: 'de',
          pageLabel: 'page', // for 'pages' mode
          allLabel: 'All',
        },
        search:{
            enabled: false,
            trigger: 'keyup',
            placeholder: 'Rechercher dans la table',
        }
    };
  },
  computed: mapState({
    agencies: state => state.atm.all
  }),
  created () {
    
  },
  methods:{
    formatFn: function (value) {
        return value != null ? value : null
    },
    async get_all_approvisionnementguichet(){
        this.$store.dispatch('appro/get_all_approvisionnementguichet').then(()=>{

          return this.rows =  store.getters['appro/rowsGuichet'];
        })
    },
    can(perm){
        return store.getters['auth/can'](perm)
    }
  },
  mounted(){
    this.get_all_approvisionnementguichet()
  }
  
}
</script>
